import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, match } from 'react-router-dom';
import { Draft, DraftProps } from '../../domain/Draft';
import { Make, Model, RiskProps } from '../../domain/Risk';
import { CoveragesProps, PolicyholderProps } from '@qover/domain';
import { EntityType } from '@qover-private/protos-web/qover/dojo/contracts/v1/policyholder';
import { ProcessingLoader } from '@qover/molecules';

type TeslaCreateDraftProps = {
  match: match;
  handleCreateOnMount: (draft: Draft) => Promise<Draft>;
};

const models = {
  S: Model.MODEL_S,
  3: Model.MODEL_3,
  X: Model.MODEL_X,
  Y: Model.MODEL_Y,
};

const entityTypes = {
  Person: EntityType.ENTITY_TYPE_PERSON,
  Company: EntityType.ENTITY_TYPE_COMPANY,
};

const TeslaCreateDraft = (props: TeslaCreateDraftProps) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const { handleCreateOnMount } = props;
  const search = new URLSearchParams(location.search);

  useEffect(() => {
    if (!search.get('id')) {
      const locale = search.get('locale');
      const model = search.get('model');
      const firstName = search.get('policyholderFirstName');
      const entityType = search.get('policyHolderType');
      const lastName = search.get('policyholderLastName');
      const number = search.get('policyholderAdressNumber');
      const street = search.get('policyholderAdressStreet');
      // const zip = search.get('policyholderAdressZIP');
      const city = search.get('policyholderAdressCity');
      const zip = search.get('policyholderAdressZip');

      if (
        !model &&
        !firstName &&
        !entityType &&
        !lastName &&
        !number &&
        !street &&
        !zip &&
        !city &&
        !zip
      ) {
        return;
      } else {
        setLoading(true);
      }

      const policyholder: PolicyholderProps = {
        firstName: firstName || undefined,
        entityType: entityTypes[entityType as keyof typeof entityTypes],
        lastName: lastName || undefined,
        address: {
          number: number || undefined,
          street: street || undefined,
          zip: zip || undefined,
          city: city || undefined,
        },
      };

      const risk: RiskProps = {
        make: Make.MAKE_TESLA,
        model: models[model as keyof typeof models],
      };

      const [language, country] = (locale || '').split('-');

      const draftProps: DraftProps = {
        risk,
        policyholder,
        settings: {
          language,
        },
        refs: {
          country,
        },
        terms: {},
        coverages: ([] as unknown) as CoveragesProps,
        totalCoverage: {},
      };

      const draft = new Draft(draftProps);

      handleCreateOnMount(draft)
        .then(response => {
          search.set('id', response.draftId as string);
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          setLoading(false);
          search.delete('model');
          search.delete('policyholderFirstName');
          search.delete('policyHolderType');
          search.delete('policyholderLastName');
          search.delete('policyholderAdressNumber');
          search.delete('policyholderAdressStreet');
          search.delete('policyholderAdressCity');
          search.delete('policyholderAdressZip');
          history.replace(`${props.match.url}/quote?${search.toString()}`);
        });
    }
  }, []);

  if (loading) {
    return <ProcessingLoader />;
  }

  return null;
};

export default TeslaCreateDraft;
